import {
  Box,
  Modal,
  Typography,
} from "@mui/material";

function NotesModal({ notesModal, setNotesModal, signupNotes }) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  return (
    <Modal
      open={notesModal}
      onClose={() => setNotesModal(false)}
      aria-labelledby="Signup Notes"
      aria-describedby="Signup Notes"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Signup Notes
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          {signupNotes}
        </Typography>
      </Box>
    </Modal>
  );
}

export default NotesModal;
